import { Record } from 'immutable'

export class ServiceJob extends Record({
    id: undefined,
    code: undefined,
    name: undefined,
    duration: undefined,
    price: undefined,
}) {}
